//@ts-check
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { UploadQueuePanel } from '@/components/common/UploadQueuePanel.jsx';
import { Sidebar } from '@/components/layout/Sidebar.jsx';
import { useBranding } from '@/hooks/useBranding.js';

/**
 * Authenticated app chrome: sidebar + main content.
 * @returns {import('react').ReactElement}
 */
export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  useBranding();

  return (
    <div className="flex h-dvh max-h-dvh overflow-hidden bg-page">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <main className="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
      <UploadQueuePanel />
    </div>
  );
}
